import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class Disclaimer extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {

  }

  add_user_info(){
    let cutThis = this;
    var web_token = $('#web_token').val();
    if($("#accepted_flag").is(':checked')){
         var body = new FormData();
         body.append('web_token',web_token);
         body.append('function','i_accept_disclaimer');
         var url      = '';
         if(window.location.host ==="localhost:3000"){
           url = "http://localhost/bylawsindia/php/home_url.php";
         }else{
           url = "/php/home_url.php";
         }
         axios({
              method: 'POST',
              url: url,
              data: body
          })
          .then(function (res) {
            var data = res.data;
            window.model_hide();
          })
          .catch(function (error) {
              console.log(error);
          });
    }else{
      $('#accept_text').addClass('color_red');
    }

  }


  render() {
    return (
      <div class="modal fade" id="myModal" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="page_titlte">Disclaimer</h4>
            </div>
            <div class="modal-body">
            <div class="chat-body chat-body-2 chat-body_no">
             <p>
                The Bar Council of India does not permit advertisement or solicitation by advocates in any form or manner.
                By accessing this website, www.bylawsindia.com, you acknowledge and confirm that you are seeking information relating to Bylaws India on your own accord and that there has been no form of solicitation, advertisement or inducement by Bylaws India or its members.
                The content of this website is for informational purposes only and should not be interpreted as soliciting or advertisement.
                No material/information provided on this website should be construed as legal advice. Bylaws India shall not be liable for consequences of any action taken by relying on the material/information provided on this website.
                The contents of this website are the intellectual property of Bylaws India.
             </p>
             <p><input type="checkbox" name="accepted_flag" id="accepted_flag" value="accepted"/> <span id="accept_text">I accept the above.</span></p>
            </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-default" onClick={this.add_user_info.bind(this)}>PROCEED TO WEBSITE</button>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Disclaimer;
